module.exports = __webpack_public_path__ + "static/5-golden-ram-line-c31a61a73bcab9762e082d98bd53fe30.png";